var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mines"},[_c('div',{staticClass:"mines-container"},[_c('MinesControls'),_c('MinesGame')],1),_c('Bets')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }